import { Component, OnInit, Output, EventEmitter, Input, ViewChild, inject } from '@angular/core';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { EmployeeView, ActiveEmployeeService, EmployeeService } from 'planner-shared';
import {EmployeeAssignedTasksComponent} from "../tasks/assigned/employee-assigned-tasks.component";

@UntilDestroy()
@Component({
    selector: 'app-employee-info',
    templateUrl: './employee-info.component.html',
    standalone: false
})
export class EmployeeInfoComponent implements OnInit {
    private readonly activeEmployeeService = inject(ActiveEmployeeService);
    private readonly employeeService = inject(EmployeeService);

    public employee$: Observable<EmployeeView>;

    @Input() public updating: boolean;
    @Input() public disableDrag: boolean;
    @Output() public changed = new EventEmitter<void>();
    @Output() public undraggableStateChanged = new EventEmitter<boolean>();
    @Output() public shiftSplitEmitter = new EventEmitter<void>();
    @ViewChild(EmployeeAssignedTasksComponent) public employeeAssignedTasksComponent: EmployeeAssignedTasksComponent;

    ngOnInit(): void {
        this.employee$ = this.activeEmployeeService.getActiveEmployee().pipe(
            untilDestroyed(this),
            switchMap(employee => this.employeeService.getEmployee(employee.workHourId))
        );
    }
}
